/**
 * The tab that owns the Beacon WebSocket forwards received messages to the other
 * tabs. BroadcastChannel does not echo back to the sender.
 */
const CHANNEL_NAME = 'rp-beacon-events';

export type BeaconRelayHandler = (type: string, data: unknown) => void;

type RelayEnvelope = {
  type: string;
  data: unknown;
};

let channel: BroadcastChannel | null = null;

export function startBeaconMessageRelay(handler: BeaconRelayHandler): void {
  if (channel || typeof BroadcastChannel === 'undefined' || typeof window === 'undefined') {
    return;
  }
  channel = new BroadcastChannel(CHANNEL_NAME);
  channel.addEventListener('message', (event: MessageEvent<RelayEnvelope>) => {
    const envelope = event.data;
    if (!envelope?.type) return;
    handler(envelope.type, envelope.data);
  });
}

export function publishBeaconMessage(type: string, data: unknown): void {
  if (!channel) return;
  try {
    channel.postMessage({ type, data });
  } catch {
    /* payload was not structured-cloneable */
  }
}
